import React from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import styles from './Confirm.styles';
import Button from '../../inputs/button/Button';
import Icon from '../icon/Icon';

const Confirm = props => {
  const deleteText = props.deleteText || I18n.t('delete.confirmDelete');
  return (
    <div className={css(styles.base)}>
      <div className={css(styles.text)}>
        <p className={css(styles.p)}>{deleteText}</p>
        <p className={css(styles.p)}>{props.itemName}</p>
      </div>
      <div className={css(styles.actions)}>
        <Button styles={[styles.btn, styles.confirm]} onClick={props.confirm}>
          <Icon value="trash" styles={styles.icon} />
          {I18n.t('delete.deleteIt')}
        </Button>
        <Button styles={[styles.btn, styles.deny]} onClick={props.deny}>
          <Icon value="checkmark-circle" styles={styles.icon} />
          {I18n.t('delete.keepIt')}
        </Button>
      </div>
    </div>
  );
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/common/confirm/Confirm.js